import { Component, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { PromoPriceFilters, promoPriceFiltersMap } from '@models/promo-price-model';
import { Subject } from 'rxjs';
import { StoreService } from 'src/app/container/configuration/store-configuration/store.service';
import { PromoPriceService } from '../promo-price.service';
import { isNilty } from '@core/utils.service';
import { ZionStore } from '@models/publications/published-store-model';
import { Supplier } from '@models/supplier-model';
import { SuppliersService } from '../../../suppliers/suppliers.service';
import { StockLocation } from '@models/stock-location-model';
import { StockLocationsService } from '../../../stock-locations/stock-locations.service';

@Component({
  selector: 'app-promo-price-filters',
  templateUrl: './promo-price-filters.component.html',
  styleUrls: ['./promo-price-filters.component.css'],
})
export class PromoPriceFiltersComponent implements OnInit {
  @Output() onFilter = new Subject<PromoPriceFilters>();

  filterForm: FormGroup;

  public openFilter = false;
  filters: PromoPriceFilters;
  filtersMap = [];

  stores: ZionStore[] = [];
  suppliers: Supplier[] = [];
  stockLocations: StockLocation[] = [];

  constructor(
    private promoPriceService: PromoPriceService,
    private storeService: StoreService,
    private supplierService: SuppliersService,
    private stockLocationsService: StockLocationsService
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      storeCode: new FormControl(),
      productBarcode: new FormControl(),
      range: new FormGroup({
        dateFrom: new FormControl(),
        dateTo: new FormControl(),
      }),
      supplierCode: new FormControl(),
    });

    if (isNilty(this.promoPriceService.promoPriceFilters)) {
      this.promoPriceService.promoPriceFilters = new PromoPriceFilters();
    }

    this.filters = this.promoPriceService.promoPriceFilters;

    this.storeService.getAllStores().subscribe((resp: ZionStore[]) => (this.stores = resp));
    this.supplierService.getAllSuppliers().subscribe((resp: Supplier[]) => (this.suppliers = resp));
    this.stockLocationsService.getAllStockLocations().subscribe((resp) => (this.stockLocations = resp));
  }

  openEvent() {
    this.openFilter = this.openFilter !== true;
  }

  closeEvent() {
    this.openFilter = false;
  }

  onSubmitFilters() {
    this.updateFiltersMap();
    this.promoPriceService.promoPriceFilters.pageNumber = 0;
    this.onFilter.next(this.setPromoPriceFilters());
  }

  resetFilters() {
    this.filters = new PromoPriceFilters();
    this.promoPriceService.promoPriceFilters = this.filters;
    this.filterForm.reset();
    this.onSubmitFilters();
  }

  updateFiltersMap() {
    this.filtersMap = promoPriceFiltersMap(
      this.filterForm.value.storeCode,
      this.filterForm.value.productBarcode,
      this.filterForm.value.range.dateFrom,
      this.filterForm.value.range.dateTo,
      this.filterForm.value.supplierCode,
      this.filterForm.value.stockLocationCode
    );
  }

  setPromoPriceFilters() {
    this.filters.storeCode = isNilty(this.filterForm.value.storeCode) ? null : this.filterForm.value.storeCode;
    this.filters.barcodes = isNilty(this.filterForm.value.productBarcode) ? null : this.filterForm.value.productBarcode.split('\n');
    this.filters.dateFrom = this.filterForm.value.range.dateFrom;
    this.filters.dateTo = this.filterForm.value.range.dateTo;
    this.filters.supplierCode = isNilty(this.filterForm.value.supplierCode) ? null : this.filterForm.value.supplierCode;
    this.filters.stockLocationCode = isNilty(this.filterForm.value.stockLocationCode) ? null : this.filterForm.value.stockLocationCode;

    return this.filters;
  }
}
